import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notification-settings',
  templateUrl: './notification-settings.page.html',
  styleUrls: ['./notification-settings.page.scss'],
})
export class NotificationSettingsPage implements OnInit {
  state = 'on';

  constructor() { }

  ngOnInit() {
    document.title = 'Notification Settings | Bank3D';
  }

}
